export class PersonUtils {
    private static getCentury (value: string): number {
        if ((value === '1') || (value === '2')) {
            return 1800
        }
        if ((value === '3') || (value === '4')) {
            return 1900
        }
        if ((value === '5') || (value === '6')) {
            return 2000
        } else {
            return 2100
        }
    }

    static calculateAge (personCode: string): number {
        // we don't validate personCode, as it comes from backend and we trust it
        const year = this.getCentury(personCode.substr(0, 1)) + Number(personCode.substr(1, 2))
        const month = Number(personCode.substr(3, 2)) - 1
        const day = Number(personCode.substr(5, 2))

        const currentDate = new Date(Date.now())
        const age = currentDate.getFullYear() - year
        if (currentDate.getMonth() > month) {
            return age
        } else if (currentDate.getMonth() < month) {
            return age - 1
        } else {
            if (currentDate.getDate() >= day) {
                return age
            } else {
                return age - 1
            }
        }
    }
}
